import VCardTicketWarning from './index.vue';

export default {
  install: (Vue) => Vue.component('VCardTicketWarning', VCardTicketWarning),
};
